import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import { connect } from 'react-redux'
import { interactionsTypeActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import moment from 'moment'
import Moment from 'react-moment'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '340px'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '14px 0'
  },
  wrapperTable: {
    maxWidth: '100%',
    overflow: 'auto',
    position: 'relative',
    '& > div': {
      minWidth: '530px'
    }
  }
})

class LogsModal extends Component {
  render() {
    const { fullScreen, onClose, open = false, loadingLogs, logs, classes } = this.props

    return (
      <div>
        <Dialog
          modalId="tipos-interacao-logs"
          fullScreen={fullScreen}
          open={open}
          onClose={onClose}
        >
          {loadingLogs ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id="tipos-interacao-logs-title">
                Tipos de interação — Logs de alterações
              </DialogTitle>
              <DialogContent>
                <Paper className={classes.wrapperTable} elevation={4}>
                  <Table
                    fixedHeader={true}
                    width={'990px'}
                    wrapperStyle={{
                      display: 'flex',
                      flexDirection: 'column',
                      minWidth: '530px',
                      maxHeight: 'var(--crud-table-height)'
                    }}
                  >
                    <TableHeader
                      displaySelectAll={false}
                      className={classes.tableHeader}
                      adjustForCheckbox={false}
                    >
                      <TableRow>
                        <TableHeaderColumn>Usuário</TableHeaderColumn>
                        <TableHeaderColumn>Ação</TableHeaderColumn>
                        <TableHeaderColumn>Data/Hora</TableHeaderColumn>
                      </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false} className={classes.tableBody}>
                      {(logs || []).length ? (
                        (logs || []).map(log => {
                          return (
                            <TableRow key={log._id}>
                              <TableRowColumn>
                                {((log || {}).usuario || {}).nome || '---'}
                              </TableRowColumn>
                              <TableRowColumn>{(log || {}).acao || '---'}</TableRowColumn>
                              <TableRowColumn>
                                {(log || {}).createdAt ? (
                                  <Moment locale={'br'} format={'DD/MM/YYYY, HH:mm'}>
                                    {(log || {}).createdAt}
                                  </Moment>
                                ) : (
                                  '---'
                                )}
                              </TableRowColumn>
                            </TableRow>
                          )
                        })
                      ) : (
                        <TableRow>
                          <TableRowColumn>
                            <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                              Não há registros.
                            </Typography>
                          </TableRowColumn>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Paper>
              </DialogContent>
              <DialogActions>
                <Button color="primary" variant="raised" onClick={onClose}>
                  Fechar
                </Button>
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

LogsModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    loadingLogs: state.interactionsType.loadingLogs,
    open: state.interactionsType.openLogsModal,
    logs: state.interactionsType.logs
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onClose: () => {
      dispatch(interactionsTypeActions.closeLogsModal())
    },
    fetchLogs: () => {
      dispatch(interactionsTypeActions.fetchLogs())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(LogsModal)))



// WEBPACK FOOTER //
// ./src/containers/InteractionsType/LogsModal.js